
import { SystemPlan } from "@ews/react-data";
import { useL10n } from "@ews/react-localization-context";
import { PushCategory } from "@ews/zlt-events";
import { IonButton, IonCard, IonCardContent, IonCardHeader, IonCardTitle, IonIcon, IonItem, IonLabel, IonList, IonSegment, IonSegmentButton } from "@ionic/react";
import { add, chevronDownOutline, chevronUpOutline } from "ionicons/icons";
import "leaflet/dist/leaflet.css";
import { useState } from "react";
import { Link } from "react-router-dom";
import { useNamedRoutes } from "../../../NamedRoutes";
import { usePersistentState } from "../../../Persistence";
import { useIsMobile } from "../../../Responsive";
import NewPlanPageModal from "../NewPlanPage/NewPlanPage";
import style from "./Floors.module.scss";
import { Props } from "./types";


export function loadImageBounds(src: string | null, onLoad: (size: [number, number]) => void)
{
    const img = new Image();
    img.src = src || "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mP8z8BQDwAEhQGAhKmMIQAAAABJRU5ErkJggg==";
    img.onload = () => onLoad([img.height, img.width]);//
}



export function getEventColor(rtm: PushCategory)
{
    switch (rtm) {
        case PushCategory.FireAlarm:
            return "firealarm";
        case PushCategory.PreAlarm:
            return "prealarm";
        case PushCategory.Fault:
            return "fault";
        case PushCategory.Disablement:
            return "disablement";
        case PushCategory.TestActivation:
            return "testactivation";
        default:
            return "no-event";
    }
}

const Floors: React.FC<Props> = ({
    systemId,
    floors,
    alarmFloors = [],
    events,
    current,
    onChange,
    onContext,
    onShowFloors,
    showFloors = true
}) =>
{
    const [planEdit] = usePersistentState<boolean>("authorizationLevelPlan");

    const { generate, router } = useNamedRoutes();

    const [isNewPlanOpen, setIsNewPlanOpen] = useState(false);
    const [showContent, setShowContent] = useState(showFloors);

    const { translate: t } = useL10n();
    const mobileView = useIsMobile();

    // console.log("Floors.tsx: isNewPlanOpen, planEdit, mobileView", isNewPlanOpen, planEdit, mobileView);

    let sortedFloors: typeof floors = [];
    if (!floors) {
        console.log("falsy floors!");
    }
    else {
        sortedFloors = [...floors!].sort((a, b) =>
        {
            if (a.isMain !== b.isMain) return a.isMain ? -1 : 1;
            return a.floor! - b.floor!;
        });
    }

    function clickHandler(floor: SystemPlan)
    {
        const link = generate('system:plan', { planId: floor.id });

        router?.push(link);
    }


    function highlightEffect(floor: SystemPlan)
    {
        if (alarmFloors.includes(floor.id!)) {
            return "danger";
        }

        if (current) {
            if (current.id === floor.id) return "primary";
        }

        return "secondary";
    }

    return mobileView ?
        <IonSegment color={"dark"} scrollable>
            {sortedFloors.map((floor, index) =>
            {
                return <IonSegmentButton
                    //color={current && floor.floor === current.floor ? "secondary" : undefined}
                    //color={alarmFloors.includes(floor.id!) ? 'danger' : 'secondary'}
                    key={index}
                    value={floor.label}
                    color={highlightEffect(floor)}
                    className={style[`floor-button-${highlightEffect(floor)}`]}
                    onClick={() =>
                    {
                        clickHandler(floor);
                    }}>
                    <Link to={generate('system:plan', { planId: floor.id })}>{floor.label}</Link>
                </IonSegmentButton>;
            })}
        </IonSegment>
        :
        <>
            <IonCard
                className={`${style.floorCard} ${planEdit ? "" : style.fullHeight} ${!showContent ? style.hideContent : ""}`}>

                <IonCardHeader color={"dark"}>

                    <IonItem color={"dark"}>
                        {planEdit ? <IonButton className={style.showContentBtn} onClick={() =>
                        {
                            const state = !showContent;
                            setShowContent(state);
                            onShowFloors && onShowFloors(state);

                        }}><IonIcon icon={showContent ? chevronUpOutline : chevronDownOutline}></IonIcon></IonButton>
                            : null}
                        <IonCardTitle className={style.textCenter}>{t("PLG_USER_PROFILE_LST_FIELD_FIREALARM_GOTO_ELS")}</IonCardTitle>
                        {planEdit ? <IonButton
                            slot="end"
                            color={"success"}
                            onClick={() =>
                            {
                                setIsNewPlanOpen(true);
                            }}
                        >
                            <IonIcon icon={add} />
                        </IonButton> : null}
                    </IonItem>
                </IonCardHeader>

                {showContent ? <IonCardContent className={`${style.content} ${planEdit ? "" : style.fullHeight}`}>
                    <IonList>
                        {sortedFloors.map((floor, index) =>
                        {
                            const color = getEventColor(events[floor.id!] || PushCategory.None);

                            return <IonItem
                                key={index}
                                //color={highlightEffect(floor)}
                                //color={alarmFloors.includes(floor.id!) ? 'danger' : 'secondary'}
                                className={`${style[color]} ${style.pointer}`}
                                onClick={() =>
                                {
                                    clickHandler(floor);
                                }}
                                onContextMenu={(e) =>
                                {
                                    e.preventDefault();
                                    if (planEdit && onContext) onContext(floor);
                                }}
                            >
                                <IonLabel>{floor.label}</IonLabel>
                            </IonItem>;
                        })}
                    </IonList>
                </IonCardContent>
                    : null}
            </IonCard>

            <NewPlanPageModal
                isOpen={isNewPlanOpen}
                systemId={systemId || ""}
                list={floors}
                onDismiss={(isOpen) =>
                {
                    setIsNewPlanOpen(isOpen);
                }}
            />
        </>;
};

export default Floors;
